// @flow
import ResourceCollection from "../base/ResourceCollection";
import ChoiceAttributeOptionModel from "../attributes/ChoiceAttributeOptionModel";

import type { ModelOptions } from "../types";

/**
 */
class LookupOptionCollection extends ResourceCollection<ChoiceAttributeOptionModel> {
  /**
   */
  static create(
    data: Object,
    contributions: Object,
    modelOptions?: ModelOptions,
  ): LookupOptionCollection {
    const collection = new LookupOptionCollection();

    if (data.options && contributions.options) {
      data.options.forEach((option) => {
        collection.add(
          new ChoiceAttributeOptionModel(
            [],
            {
              ...option,
              optionType: this.getOptionType(option, contributions),
              elementsContributions: contributions.options[0].elements,
            },
            {
              ...modelOptions,
              referenceDate: new Date().toISOString().split("T")[0],
            },
          ),
        );
      });
    }

    return collection;
  }

  /**
   */
  static getOptionType(option: Object, contributions: Object): string {
    if (contributions.optionType) {
      return contributions.optionType;
    }
    if (option._links?.download?.[0].name === "avatar") {
      return "user";
    }
    return "generic";
  }
}

export default LookupOptionCollection;
